import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PATH } from '@app/constants';
import { UserInfo } from '@interfaces/app';

@Component({
  selector: 'mnf-dashboard-v2-banner',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './dashboard-v2-banner.component.html',
  styleUrl: './dashboard-v2-banner.component.scss'
})
export class DashboardV2BannerComponent{

  @Input() title!: string;
  @Input() description!: string;
  @Input() image!: string;
  @Input() button!: string;
  @Input() routerLink!: string;
  user: UserInfo;
  path = PATH;

  get splitTitle(){
    const words = this.title.split(' ');
    const midPoint = Math.ceil(words.length / 2);
    return {
      first: words.slice(0, midPoint).join(' '),
      second: words.slice(midPoint).join(' ')
    };
  }

}
